import * as types from '../constants/actionTypes';

// Fetch All Product Categories
export const fetchProductCategoriesRequest = (filters = {}) => ({
  type: types.FETCH_PRODUCT_CATEGORIES_REQUEST,
  payload: { filters }
});

export const fetchProductCategoriesSuccess = (categories, totalCount) => ({
  type: types.FETCH_PRODUCT_CATEGORIES_SUCCESS,
  payload: { categories, totalCount }
});

export const fetchProductCategoriesFailure = (error) => ({
  type: types.FETCH_PRODUCT_CATEGORIES_FAILURE,
  payload: { error }
});

// Fetch Active Product Categories
export const fetchActiveProductCategoriesRequest = () => ({
  type: types.FETCH_ACTIVE_PRODUCT_CATEGORIES_REQUEST
});

export const fetchActiveProductCategoriesSuccess = (categories, totalCount) => ({
  type: types.FETCH_ACTIVE_PRODUCT_CATEGORIES_SUCCESS,
  payload: { categories, totalCount }
});

export const fetchActiveProductCategoriesFailure = (error) => ({
  type: types.FETCH_ACTIVE_PRODUCT_CATEGORIES_FAILURE,
  payload: { error }
});

// Get Product Category by ID
export const getProductCategoryRequest = (id) => ({
  type: types.GET_PRODUCT_CATEGORY_REQUEST,
  payload: { id }
});

export const getProductCategorySuccess = (category) => ({
  type: types.GET_PRODUCT_CATEGORY_SUCCESS,
  payload: { category }
});

export const getProductCategoryFailure = (error) => ({
  type: types.GET_PRODUCT_CATEGORY_FAILURE,
  payload: { error }
});

// Create Product Category
export const createProductCategoryRequest = (categoryData) => ({
  type: types.CREATE_PRODUCT_CATEGORY_REQUEST,
  payload: { categoryData }
});

export const createProductCategorySuccess = (category) => ({
  type: types.CREATE_PRODUCT_CATEGORY_SUCCESS,
  payload: { category }
});

export const createProductCategoryFailure = (error) => ({
  type: types.CREATE_PRODUCT_CATEGORY_FAILURE,
  payload: { error }
});

// Update Product Category
export const updateProductCategoryRequest = (id, categoryData) => ({
  type: types.UPDATE_PRODUCT_CATEGORY_REQUEST,
  payload: { id, categoryData }
});

export const updateProductCategorySuccess = (category) => ({
  type: types.UPDATE_PRODUCT_CATEGORY_SUCCESS,
  payload: { category }
});

export const updateProductCategoryFailure = (error) => ({
  type: types.UPDATE_PRODUCT_CATEGORY_FAILURE,
  payload: { error }
});

// Set Editing Category
export const setProductCategoryEditing = (category) => ({
  type: types.SET_PRODUCT_CATEGORY_EDITING,
  payload: { category }
});

// Clear Editing Category
export const clearProductCategoryEditing = () => ({
  type: types.CLEAR_PRODUCT_CATEGORY_EDITING
});